import styled from 'styled-components';
import Collapse from 'rc-collapse';
import { Props } from './types';

type T = Pick<Props, 'palette'>;

export const PanelStyled = styled(Collapse.Panel)<T>`
  &.rc-collapse-item {
    padding: 0;
    color: #666;
    transition: 0.2s background ease-in;

    & > .rc-collapse-header {
      --background: ${({ palette }) => {
        switch (palette) {
          case 'primary': {
            return '#ea475c';
          }
          default: {
            return '#292929';
          }
        }
      }};

      background: var(--background);
      display: grid;
      grid-template-columns: 1fr auto;
      grid-template-areas: 'content arrow';
      align-items: center;
      overflow: hidden;
      line-height: 1;
      padding: 0;

      &:hover {
        background: ${({ palette }) => {
          switch (palette) {
            case 'primary': {
              return '#ea475ccc';
            }
            default: {
              return '#292929cc';
            }
          }
        }};
      }

      & .arrow {
        grid-area: arrow;
        border: none;
        display: block;
        width: 40px;
        margin: 0;
        position: relative;
        top: 0;
        background: transparent;
        transition: 0.2s transform ease-in;
        transform: rotate(180deg);
        padding-bottom: 100%;

        &:before {
          content: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3Ctitle%3EChevron Up%3C/title%3E%3Cpath fill='none' stroke='%23727272' stroke-linecap='round' stroke-linejoin='round' stroke-width='48' d='M112 328l144-144 144 144'/%3E%3C/svg%3E");
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          padding: 10px;
        }
      }

      & .arrow + * {
        grid-area: content;
      }
    }

    &.rc-collapse-item-active {
      & > .rc-collapse-header {
        & .arrow {
          transform: rotate(0deg);
        }
      }
    }
  }
`;
